import { SubscriptionStoreState, useSubscriptionStore } from '../subscriptionStore';

export const DEFAULT_HD_WORDS_GRANT = 450000;

export const getHdWordsGrant = (state?: SubscriptionStoreState) => {
  const latestState = state ?? useSubscriptionStore.getState();
  return latestState.entitlements?.nextHdWordsGrant ?? DEFAULT_HD_WORDS_GRANT;
};
